import { render, staticRenderFns } from "./AggiornaCertificato.vue?vue&type=template&id=305a5744"
import script from "./AggiornaCertificato.vue?vue&type=script&lang=js"
export * from "./AggiornaCertificato.vue?vue&type=script&lang=js"
import style0 from "./AggiornaCertificato.vue?vue&type=style&index=0&id=305a5744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports